
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";
import { BaseUrl } from "../../BaseUrl";

// Get Table Data
export const ProjectWiseSurveyorTableDataAPI = createAsyncThunk("ProjectWiseSurveyorTableData", async ({ data }) => {
    const {
        M_ProjectID,
        M_StateID,
        M_RegionalOfficeID,
        M_FieldStationOfficerID,
        M_SurveyorName,
        Mobile,
        M_TableUserMasterID,
        FromTop,
        ToTop,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

   
    return fetch(`${BaseUrl}/Master/Get_Web_M_Project_Wise_Surveyor_Select?M_ProjectID=${M_ProjectID}&M_StateID=${M_StateID}&M_RegionalOfficeID=${M_RegionalOfficeID}&M_FieldStationOfficerID=${M_FieldStationOfficerID}&M_SurveyorName=${M_SurveyorName}&Mobile=${Mobile}&M_TableUserMasterID=${M_TableUserMasterID}&Top=${ToTop}`, requestOptions) 
    .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    return result.data
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const ProjectWiseSurveyorTableDataSlice = createSlice({
    name: "ProjectWiseSurveyorTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProjectWiseSurveyorTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ProjectWiseSurveyorTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ProjectWiseSurveyorTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const ProjectWiseSurveyorTableDataReducer = ProjectWiseSurveyorTableDataSlice.reducer


// Get Table Data (Popup Gride)

export const ProjectWiseSurveyorDistrictPopUpTableDataAPI = createAsyncThunk("ProjectWiseSurveyorDistrictPopUpTableData", async ({ Data }) => {
    const {
        M_ProjectID,
        M_StateID,
        M_Surveyor_TableUserID,
        Flag,
        M_TableUserMasterID,
        M_FieldStationOfficerID,
        Top,
        token
    } = Data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    // return fetch(`${BaseUrl}/Master/Get_Web_M_Project_Wise_Surveyor_District_Select?M_StateID=${M_StateID}&M_TableUserMasterID=${M_TableUserMasterID}&M_ProjectID=${M_ProjectID}&M_Surveyor_TableUserID=${M_Surveyor_TableUserID}&Flag=${Flag}&Top=${Top}`, requestOptions)
    return fetch(`${BaseUrl}//Master/Get_Web_M_Project_Wise_Surveyor_District_Select?M_ProjectID=${M_ProjectID}&M_StateID=${M_StateID}&M_FieldStationOfficerID=${M_FieldStationOfficerID}&M_Surveyor_TableUserID=${M_Surveyor_TableUserID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}&Top=${Top}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    return result.data
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const ProjectWiseSurveyorDistrictPopUpTableDataSlice = createSlice({
    name: "ProjectWiseSurveyorDistrictPopUpTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProjectWiseSurveyorDistrictPopUpTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ProjectWiseSurveyorDistrictPopUpTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ProjectWiseSurveyorDistrictPopUpTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const ProjectWiseSurveyorDistrictPopUpTableDataReducer = ProjectWiseSurveyorDistrictPopUpTableDataSlice.reducer

// InsertUpdate Table Data

export const ProjectWiseSurveyorPostAPI = createAsyncThunk("ProjectWiseSurveyorPost", async ({ data }) => {
    const {
        M_ProjectID,
        M_StateID,
        M_RegionalOfficeID,
        M_FieldStationOfficerID,
        M_Surveyor_TableUserID,
        M_DistrictID,
        M_TableUserMasterID,
        Flag,
        token,
        handleIsPost
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ProjectID", M_ProjectID);
    formdata.append("M_StateID", M_StateID);
    formdata.append("M_RegionalOfficeID", M_RegionalOfficeID);
    formdata.append("M_FieldStationOfficerID", M_FieldStationOfficerID);
    formdata.append("M_Surveyor_TableUserID", M_Surveyor_TableUserID);
    formdata.append("M_DistrictID",M_DistrictID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    formdata.append("Flag", Flag);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Master/Post_Web_M_Project_Wise_Surveyor_InsertUpdate`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                // handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const ProjectWiseSurveyorPostSlice = createSlice({
    name: "ProjectWiseSurveyorPost",
    initialState: {
        isPostLoading: false,
        Data: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProjectWiseSurveyorPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(ProjectWiseSurveyorPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.CropNametableData = action.payload;
        });
        builder.addCase(ProjectWiseSurveyorPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.CropNametableData = null;

        });
    },
})

export const ProjectWiseSurveyorPostReducer = ProjectWiseSurveyorPostSlice.reducer

